module.exports = __webpack_public_path__ + "img/ft_2.c6ed5662.jpg";